import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGS, type Lang } from '../i18n';
import './LanguageSwitcher.scss';

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = (i18n.resolvedLanguage ?? i18n.language).slice(0, 2) as Lang;

  return (
    <label className="lang-switcher">
      <span className="visually-hidden">{t('footer.language')}</span>
      <select
        className="lang-switcher__select"
        value={current}
        onChange={(e) => {
          void i18n.changeLanguage(e.target.value);
        }}
      >
        {SUPPORTED_LANGS.map((lang) => (
          <option key={lang} value={lang}>
            {lang.toUpperCase()}
          </option>
        ))}
      </select>
    </label>
  );
}
